import type { CartLine } from '@repo/shopify';

export function isPackageProtectionLine(line: CartLine, productHandle: string) {
	const handle = line.merchandise.product.handle;
	const title = line.merchandise.product.title.trim().toLowerCase();

	return handle === productHandle || title === 'package protection';
}

export function splitPackageProtectionLines(lines: CartLine[], productHandle: string) {
	const visibleLines: CartLine[] = [];
	const protectionLines: CartLine[] = [];

	for (const line of lines) {
		if (isPackageProtectionLine(line, productHandle)) {
			protectionLines.push(line);
		} else {
			visibleLines.push(line);
		}
	}

	return { visibleLines, protectionLines };
}

export function getCartLinesSubtotal(lines: CartLine[]) {
	return lines.reduce((sum, line) => sum + Number.parseFloat(line.cost.totalAmount.amount), 0);
}

export function getCartLinesQuantity(lines: CartLine[]) {
	return lines.reduce((sum, line) => sum + line.quantity, 0);
}
